import React from "react";
import "./faq.scss";
import {Title} from "../../elements/Title/title";
import RichText from "../RichText/richText";
import FAQPage from "../../seo/ld-json/FAQPage";

export const Faq = props => {
    const asks = props.asks;
    const title = props.title;

    return (
        <div className={props.className}>

            {title && (
                <Title id={props.id} tag={`h2`} size20 content={title} />
            )}

            {asks.map((value, index) => (
                <>
                    <Title tag={`h3`} size16 content={value.questionText} />
                    <RichText content={value.responseText} />
                </>
            ))}

            <FAQPage asks={asks}/>
        </div>
    );
};

export default Faq;